// getters
const getters = {
  getChartData(state) {
    return state.chartData;
  },
  getReportsScreens(state) {
    return state.reportsScreens;
  },
  getTab(state) {
    return state.tab;
  },
  getSessions(state) {
    return state.sessions;
  },
  getGroups(state) {
    return state.groups;
  },
  getChargedOffSessions(state) {
    return state.chargedOffSessions;
  },
  getQueryParams(state) {
    return state.queryParams;
  },
  getExport(state) {
    return state.export;
  },
  getExportData(state) {
    return state.exportData;
  },
  getRatingData: (state) => {
    state.ratingData.votesPerRating.reverse();
    return state.ratingData;
  },
  getExportURL(state) {
    return state.exportURL;
  },
  getRoundsPlayedChart(state) {
    return state.roundsPlayedChart;
  },
  getRounds(state) {
    return state.rounds;
  },
  getDynamicYardageChart(state) {
    return state.dynamicYardageChart;
  },
  getFoodAndBeverageChart(state) {
    return state.foodAndBeverageChart;
  },
  getScorecardChart(state) {
    return state.scorecardChart;
  },
  getListenChart(state) {
    return state.listenChart;
  },
  getWatchChart(state) {
    return state.watchChart;
  },
  getGraphLoadingStates(state) {
    return state.graphLoadingStates;
  },
  getCarsByModelGraph(state) {
    return state.carsByModelGraph;
  },
  getGroupsByModelGraph(state) {
    return state.groupsByModelGraph;
  },
  getTotalCarsGraph(state) {
    return state.totalCarsGraph;
  },
  getLaunchModesChart(state) {
    return state.launchModeChart;
  },
  getTotalGroupsGraph(state) {
    return state.totalGroupsGraph;
  },
  getRoundsTableLoading(state) {
    return state.roundsTableLoading;
  },
  getScreensTableLoading(state) {
    return state.screensTableLoading;
  },
  getGroupsTableLoading(state) {
    return state.groupsTableLoading;
  },
  getSharkAnalytics(state) {
    return state.sharkAnalytics;
  },
  getGolfCarChart(state) {
    return state.golfCarChart;
  },
  getSharkGroupsChart(state) {
    return state.sharkGroupsChart;
  },
  getRondsLauchChart(state) {
    return state.roundsLaunchChart;
  },
  getCartsLauchChart(state) {
    return state.cartsLaunchChart;
  },
  getGroupsLauchChart(state) {
    return state.groupsLaunchChart;
  },
  getsharkRounds(state) {
    return state.sharkRounds;
  },
  getsharkScreens(state) {
    return state.sharkScreens;
  },
  getsharkGroups(state) {
    return state.sharkGroups;
  },
  getSharkReportsDataModel(state) {
    const all = {
      sharkUniqueRentalData: state.sharkUniqueRentalData,
      sharkAnalyticsData: state.sharkAnalyticsData,
      roundsPlayedChart: state.roundsPlayedChart, // in setRoundsPlayed
      roundsLaunchChart: state.roundsLaunchChart, // setRoundsPlayed
      getGolfCarChart: state.golfCarChart, // setSharkScreensData
      cartsLaunchChart: state.cartsLaunchChart, // setSharkScreensData
      getSharkGroupsChart: state.sharkGroupsChart, // setSharkGroupsData
      groupsLaunchChart: state.groupsLaunchChart, // setSharkGroupsData
      sharkRounds: state.sharkRounds,
      sharkScreens: state.sharkScreens,
      sharkGroups: state.sharkGroups,
      sharkAllGroups: state.sharkAllGroups,
      sharkChartData: state.chartData,
    };
    return all;
  },
  getLastEvalKey(state) {
    return state.lastEvalKey;
  },
  getTempSessions(state) {
    return state.tempSessions;
  },
};
export default getters;
